<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showCity") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #d53f07">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Name Input -->

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('TABLES.Workplaces.date')"
            v-model.trim="data.created_at"
            disabled
          />

          <!-- Start:: Polygon Map -->
          <div class="col-12 mt-4" v-if="polygonPaths.length > 0">
            <PolygonMap
              :centerLat="mapCenter.lat"
              :centerLng="mapCenter.lng"
              :readonly="true"
              :initialPaths="polygonPaths"
            />
          </div>
          <!-- End:: Polygon Map -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PolygonMap from "../../../components/general/PolygonMap.vue";

export default {
  name: "ShowCity",
  components: { PolygonMap },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        created_at: null,
        city: null,
        region: null,
        active: null,
      

},
      cities: [],
      polygonPaths: [],
      mapCenter: { lat: 30.0444, lng: 31.2357 },

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Helper method to convert GeoJSON coordinates to PolygonMap format
    convertBoundaryToPolygonPaths(boundary) {
      if (!boundary || !boundary[0]) {
        return [];
      }
      console.log(boundary);

      // GeoJSON coordinates are in [lng, lat] format, we need [lat, lng]
      return boundary.map((coord) => ({
        lat: coord[1],
        lng: coord[0],
      }));
    },

    // Helper method to calculate center point from polygon paths
    calculateMapCenter(paths) {
      if (!paths || paths.length === 0) {
        return { lat: 30.0444, lng: 31.2357 }; // Default center
      }
      const totalLat = paths.reduce((sum, point) => sum + +point.lat, 0);
      const totalLng = paths.reduce((sum, point) => sum + +point.lng, 0);

      return {
        lat: totalLat / paths.length,
        lng: totalLng / paths.length,
      };
    },

    // start show data
    async showCity() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities/${this.$route.params?.id}`,
        });

        const cityData = res.data.data.City;
        this.data.name_ar = cityData.name_ar;
        this.data.name_en = cityData.name_en;
        this.data.created_at = cityData.created_at;
        this.data.active = cityData.is_active;

        // Parse and convert area_points data
        if (cityData.area_points) {
          this.polygonPaths = cityData.area_points.map((point) => ({
            lat: +point.lat,
            lng: +point.lng,
          }));

          this.mapCenter = this.calculateMapCenter(this.polygonPaths);
        }
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.showCity();
  },
};
</script>
